
export default {
    data() {
        return {
            index: 0,
            timeoutIndex: -1,
            title: ''
        }
    },
    methods: {
    },
    beforeDestroy() {
      clearTimeout(this.timeoutIndex)
      console.log(this.title, '组件销毁')
    }
}